// stores/postService.js
import { defineStore } from 'pinia';
import { useRuntimeConfig } from '#app';

export const usePostServiceStore = defineStore('postService', {
  state: () => ({
    posts: [],
    banners: [],
    works: [],
    overview: [],
    services: [],
    isLoading: false,
    error: null,
  }),
  actions: {

    async fetchIntroDialog() {

      const { locale } = useI18n();
      const { baseApi } = useApiBase();

      try {

        const response = await $fetch(`${baseApi}/${locale.value}/posts/intro-dialog`);

        this.posts = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },

    async fetchBlogData() {

      this.isLoading = true;
      this.error = null;
      const { locale } = useI18n();
      const { baseApi } = useApiBase();

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/blogs`);

        this.posts = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },
    async fetchBlogByID(id) {

      this.isLoading = true;
      this.error = null;
      const { locale } = useI18n();
      const { baseApi } = useApiBase();

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/blogs/${id}`);

        this.posts = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },
    async fetchHeroBannerData() {

      this.isLoading = true;
      this.error = null;
      const { locale } = useI18n();
      const { baseApi } = useApiBase();

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/hero-banner`);

        this.banners = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },

    async fetchHomeWorkData() {

      this.isLoading = true;
      this.error = null;
      const { locale } = useI18n();
      const { baseApi } = useApiBase();

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/work`);

        this.works = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },

    async fetchHomeOverviewData() {

      this.isLoading = true;
      this.error = null;
      const { locale } = useI18n();
      const { baseApi } = useApiBase();

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/overview`);

        this.overview = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },

    async fetchHomeServiceData() {

      this.isLoading = true;
      this.error = null;
      const { locale } = useI18n();
      const { baseApi } = useApiBase();

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/home-service`);

        this.services = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },

    async fetchServiceData(categoryPath) {

      this.isLoading = true;
      this.error = null;
      const config = useRuntimeConfig();
      const { locale } = useI18n();
      const baseApi = config.public.appApi;

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/${categoryPath}`);

        this.posts = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },
    async fetchServiceDataByID(categoryPath, id) {

      this.isLoading = true;
      this.error = null;
      const config = useRuntimeConfig();
      const { locale } = useI18n();
      const baseApi = config.public.appApi;

      try {
        const response = await $fetch(`${baseApi}/${locale.value}/posts/${categoryPath}/${id}`);

        this.posts = response?.data || [];

      } catch (err) {
        this.error = err.message || 'An error occurred while fetching the service data';
      } finally {
        this.isLoading = false;
      }
    },
  },

});
